module.exports = __webpack_public_path__ + "static/media/microsoftBlackLogo.f4f2d98d.png";